import { render, staticRenderFns } from "./documentos.vue?vue&type=template&id=6f8707ee&scoped=true&"
import script from "./documentos.component.ts?vue&type=script&lang=ts&"
export * from "./documentos.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8707ee",
  null
  
)

export default component.exports